import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './EventStatus.module.scss'
import classNames from 'classnames'

const EventStatus = ({ event, status }) => {
  const { t } = useTranslation()

  switch (status) {
    case 'inProgress':
      return (
        <div className={styles.eventStatus}>
          <div className={styles.ongoing}>
            <div className={styles.iconWrapper}>
              <i className='fa fa-repeat' aria-hidden='true'/>
            </div>
            <p>{t('events.list.status.loggingInProgress')}</p>
          </div>
        </div>
      )
    case 'noRSVP':
      return (
        <div className={styles.eventStatus}>
          <div className={styles.created}>
            <div className='d-flex'>
              <div className={styles.iconWrapper}>
                <i className='fa fa-users' aria-hidden='true'/>
              </div>
              <p>{t('events.list.status.eventInDays', { count: event.daysUntilEvent })}</p>
            </div>
            { event.confirmedEnrollmentsCount
              ? <p className={styles.attendingText}> {t('events.list.status.countAttending', { count: event.confirmedEnrollmentsCount })} </p>
              : null }
          </div>
        </div>
      )
    case 'nextRSVP':
      return (
        <div className={styles.eventStatus}>
          <div className={styles.created}>
            <div className='d-flex'>
              <div className={styles.iconWrapper}>
                <i className='fa fa-envelope' aria-hidden='true'/>
              </div>
              <p>{t('events.list.status.rsvpSendingInDays', { count: event.nextRsvp })}</p>
            </div>
            { event.confirmedEnrollmentsCount
              ? <p className={styles.attendingText}> {t('events.list.status.countAttending', { count: event.confirmedEnrollmentsCount })} </p>
              : null }
          </div>
        </div>
      )
    case 'needsPairings':
      return (
        <div className={styles.eventStatus}>
          <div className={styles.needsPairings}>
            <div className='d-flex'>
              <div className={styles.iconWrapper}>
                <i className='fa fa-users' aria-hidden='true'/>
              </div>
              <p>{t('events.list.status.needsPairings')}</p>
            </div>
            { event.confirmedEnrollmentsCount
              ? <p className={styles.attendingText}> {t('events.list.status.countAttending', { count: event.confirmedEnrollmentsCount })} </p>
              : null }
          </div>
        </div>
      )
    case 'readyToRun':
      return (
        <div className={styles.eventStatus}>
          <div className={styles.ready}>
            <div className='d-flex'>
              <div className={styles.iconWrapper}>
                <i className='fa fa-flag' aria-hidden='true'/>
              </div>
              <p>{t('events.list.status.readyToRun')}</p>
            </div>
            { event.pairedEnrollmentsCount
              ? <p className={styles.attendingText}> {t('events.list.status.countAttending', { count: event.pairedEnrollmentsCount })} </p>
              : null }
          </div>
        </div>
      )
    case 'ongoing':
      return (
        <div className={styles.eventStatus}>
          <div className={styles.ongoing}>
            <div className={styles.iconWrapper}>
              <i className='fa fa-bullhorn' aria-hidden='true'/>
            </div>
            <p>{t('events.list.status.logScores')}</p>
          </div>
        </div>
      )
    case 'completed':
      return (
        <div className={styles.eventStatus}>
          <div className={styles.completed}>
            <div className='d-flex mb-2'>
              <div className={styles.iconWrapper}>
                <i className='fa fa-check' aria-hidden='true'></i>
              </div>
              <p>{t('events.list.status.completed')}</p>
            </div>
            <div className={classNames(styles.label, styles.leaderboardLabel)}>
              <div className={styles.labelText}> {t('events.list.status.viewLeaderboard')} </div>
            </div>
          </div>
        </div>
      )
    default:
      return null
  }
}

EventStatus.propTypes = {
  event: PropTypes.shape({
    status: PropTypes.string,
    nextRsvp: PropTypes.number,
    confirmedEnrollmentsCount: PropTypes.number,
    respondedEnrollmentsCount: PropTypes.number,
    pairedEnrollmentsCount: PropTypes.number,
    daysUntilEvent: PropTypes.number,
  }),
  inProgress: PropTypes.bool,
  status: PropTypes.string,
}

export default EventStatus
